export const getNiceDate = (date) => {

    return new Date(date).toLocaleDateString('fr')
}